/* eslint-disable */
import { Button, Checkbox, Label, Modal } from "flowbite-react";
import React, { useRef } from "react";
import { FilePond } from 'react-filepond';
const RenderModal = ({
  openModal,
  handleCloseModal,
  handleSave,
  submitLoader,
  formData,
  setFormData,
  handleInputChange,
  onChangeSeriesCoverFile,
  seriesCoverOnRemove,
  isSeries,
  setIsSeries,
  seriesDescription,
  setSeriesDescription,
  categoryDetails,
  isEditing,
  editCoverPondRef ,
  editCover,
  distinctGroups,
  setDistinctGroups 
}) => {
  const rootRef = useRef(null);
  return (
    <div ref={rootRef}>
      <Modal
        root={rootRef.current ?? undefined}
        show={openModal}
        size="md"
        onClose={(e) => {
          if (!submitLoader) {
            handleCloseModal(e);
          }
        }}
        popup
      >
        <Modal.Header />
        <Modal.Body>
          <form onSubmit={handleSave}>
            <div className="space-y-6">
              <h3 className="text-xl font-medium text-gray-900 dark:text-white">
                {formData.id ? `Edit` : `Add`} Category
              </h3>
              <div>
                <div className="mb-2 block">
                  <Label htmlFor="category" value={isSeries === true ? 'Series Name': 'Name'} />
                </div>
                <input
                  disabled={isEditing}
                  id="name"
                  name="category"
                  type="text"
                  placeholder={isSeries === true ? 'Enter Series Name': 'Enter Category Name'}
                  value={formData.category}
                  onChange={handleInputChange}
                  required
                  style={{ width: '100%' }}
                />
              </div>
              <div>
                <div className="mb-2 block">
                  <Label htmlFor="group" value="Group" />
                </div>
                <select
                  id="group"
                  name="group"
                  value={formData.group}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === 'addNew') {
                      const newGroup = Number(Math.max(...distinctGroups) + 1);
                      formData.group = newGroup;
                      setDistinctGroups([...distinctGroups, newGroup]);
                      
                    } else {
                      setFormData((prevState) => ({
                        ...prevState,
                        group: Number(value),
                      }));
                    }
                  }}
                  required
                  style={{ width: '100%' }}
                >
                  {distinctGroups.map((group) => (
                    <option key={group} value={group}>
                      {group}
                    </option>
                  ))}
                  <option value="addNew">Add New Group</option>
                </select>
              </div>
              
              <div className="mb-4">
                <label htmlFor="tag" className="focunLevel">
                  <span className="focusSpan soc-input-label-span">Is it a series?</span>
                  <div className="flex items-center space-x-4">
                    <label className="flex items-center">
                      <Checkbox
                        checked={isSeries === true}
                        onChange={() => setIsSeries(true)}
                      />
                      <span className="ml-2">Yes</span>
                    </label>
                    <label className="flex items-center">
                      <Checkbox
                         checked={isSeries === false}
                         onChange={() => setIsSeries(false)}
                      />
                      <span className="ml-2">No</span>
                    </label>
                  </div>
                </label>
              </div>
              {isSeries === true && (
                  <>
                    <div>
                      <div className="mb-2 block">
                        <Label htmlFor="seriesDescription" value="Series Description" />
                      </div>
                      <input
                        id="seriesDescription"
                        name="seriesDescription"
                        type="text"
                        placeholder="Enter Series Description"
                        value={seriesDescription}
                        onChange={(e) => setSeriesDescription(e.target.value)}
                        required
                        style={{ width: '100%' }}
                      />
                    </div>
                    <div className="mb-4">
                      {isEditing && ( 
                        <><div className="flex justify-between">
                        <label
                          htmlFor="imageUpload"
                          className="block mb-1 font-normal text-gray-800 text-sm"
                        >
                          Series Cover
                        </label>
                      </div>
                      {!editCover && categoryDetails.seriesCover && (
                              <img
                                className="h-60 w-60 m-auto rounded-2xl object-cover"
                                src={categoryDetails.seriesCover}
                                alt="imageCover"
                              />
                      )}
                       <div className={editCover ? 'block' : 'hidden'}>
                        <FilePond
                          //disabled={isPosting}
                          ref={editCoverPondRef}
                          //className="newAssetPond"
                          maxFiles={1}
                          imagePreviewMinHeight={200}
                          imagePreviewMaxHeight={200}
                          onremovefile={seriesCoverOnRemove}
                          onupdatefiles={onChangeSeriesCoverFile}
                          allowImagePreview
                          acceptedFileTypes={['image/png', 'image/jpeg']}
                        />
                      </div>
                      <div className="flex justify-end mt-2 px-10">
                        <button
                          className="flex font-semibold underline"
                          onClick={() => {
                            editCoverPondRef.current.browse();
                          }}
                          type="button"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="19"
                            height="19"
                            viewBox="0 0 19 19"
                            fill="none"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M14.795 3.10281L15.8075 4.11531C16.4 4.70031 16.4 5.65281 15.8075 6.23781L5.885 16.1603H2.75V13.0253L10.55 5.21781L12.6725 3.10281C13.2575 2.51781 14.21 2.51781 14.795 3.10281ZM4.25 14.6603L5.3075 14.7053L12.6725 7.33281L11.615 6.27531L4.25 13.6403V14.6603Z"
                              fill="#041F21"
                            />
                          </svg>
                          Edit
                        </button>
                      </div>
                      </>
                      )}

                        {!isEditing && ( 
                          <>
                            <div className="flex justify-between">
                              <label
                                htmlFor="imageUpload"
                                className="block mb-1 font-normal text-gray-800 text-sm"
                              >
                                Upload Series Cover
                              </label>
                            </div>
                            <FilePond
                              className="newAssetPond"
                              maxFiles={1}
                              imagePreviewMinHeight={200}
                              imagePreviewMaxHeight={200}
                              onremovefile={seriesCoverOnRemove}
                              onupdatefiles={onChangeSeriesCoverFile}
                              allowImagePreview
                              acceptedFileTypes={['image/png', 'image/jpeg']}
                            />
                          </>
                        )}
                    </div>
                  </>
              )}
              

              <Button
                className="soc-button w-auto flex items-center justify-center px-4"
                disabled={submitLoader}
                type="submit"
              >
                {submitLoader && (
                  <>
                    <div role="status">
                      <svg
                        aria-hidden="true"
                        className="inline w-4 h-4 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="currentColor"
                        />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="currentFill"
                        />
                      </svg>
                      <span class="sr-only">Saving...</span>
                    </div>
                    &nbsp; Saving...
                  </>
                )}
                {!submitLoader && "Save"}
              </Button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default React.memo(RenderModal);
